/**
 * This enum define all tooltip text of step four
 */
export enum TooltipTexts {
    PAYMENT_METHOD = 'Recuerda que esta información se debe actualizar cada mes al momento de llevar a cabo la liquidación de la nómina.',
}
